import SeatsConverter from './SeatsConverter';
import MealsConverter from './MealsConverter';
import SelectedMealsConverter from './SelectedMealsConverter';
import Constants from '../model/AppConfiguration';
import moment from 'moment';
import NotificationsConverter from './NotificationsConverter';
import TermsConverter from './TermsConverter';
import NavigationConverter from './NavigationConverter';
import TripConverter from './TripConverter';
import PassengersConverter from './PassengersConverter';

export default { flightsWireToInt: flightsWireToInt };

function flightsWireToInt (wireFlights) {
  let intFlights = [];
  if (!wireFlights || !wireFlights.flights || !wireFlights.flights.flight) {
    intFlights = [];
  } else {
    let flights = wireFlights.flights.flight;
    if (flights.length) {
      for (let i = 0; i < flights.length; i++) {
        let wireFlight = flights[ i ];
        intFlights.push(flightWireToInt(wireFlight));
      }
    } else {
      intFlights.push(flightWireToInt(flights));
    }
  }

  return coreIntFlights(wireFlights, intFlights);
}

function coreIntFlights (wireFlights, flights) {
  const {
    action,
    gototab,
    redirecturl,
    reservationid,
    contact_objectid,
    tripType,
    settings,
    terms,
    notifications,
    contacts,
  } = wireFlights;
  let reservationId = reservationid ? parseInt(reservationid._text, 10) : 0;
  let passengerId = contact_objectid ? contact_objectid._text : '';
  let trip = TripConverter.tripWireToInt(tripType);
  let intAction = action ? action._text : '';
  let goToTab = gototab ? gototab._text : '';
  let redirectUrl = redirecturl ? redirecturl._cdata || redirecturl._text : '';
  let navigation = NavigationConverter.navigationWireToInt(settings);
  let intTerms = TermsConverter.termsWireToInt(terms);
  let intNotifications = NotificationsConverter.notificationsWireToInt(notifications);
  let passengers = PassengersConverter.passengersWireToInt(contacts);

  return {
    action: intAction,
    passengerId,
    trip,
    goToTab,
    redirectUrl,
    reservationId,
    navigation,
    terms: intTerms,
    notifications: intNotifications,
    flights,
    passengers,
  };
}

function flightWireToInt (wireFlight) {
  if (!wireFlight || !wireFlight._attributes) return {};

  const { adults, infants, flightid, routeid, routid, date, time } = wireFlight._attributes;
  let contacts = wireFlight.contact ?
    wireFlight.contact :
    wireFlight.contacts ?
      wireFlight.contacts.contact :
      wireFlight.menuItemAssignments ? wireFlight.menuItemAssignments.contact : [];
  let menuAssignments = wireFlight.menuItemAssignments ?
    wireFlight.menuItemAssignments.contact :
    [];

  return {
    adults: parseInt(adults, 10) ? parseInt(adults, 10) : 0,
    infants: parseInt(infants, 10) ? parseInt(adults, 10) : 0,
    id: flightid,
    routeId: routeid || routid,
    date: moment(date, Constants.SERVER_DATE_FORMAT).format(Constants.DATE_FORMAT),
    time,
    passengers: flightPassengersToInt(contacts),
    seats: SeatsConverter.seatsWireToInt(wireFlight.seats),
    meals: MealsConverter.mealsWireToInt(wireFlight.menu),
    selectedMeals: SelectedMealsConverter.mealsWireToInt(menuAssignments),
  };
}

function flightPassengersToInt (wirePassengers) {
  if (!wirePassengers) {
    return [];
  }
  let intPassengers = [];
  wirePassengers =
    wirePassengers && wirePassengers._attributes ? wirePassengers._attributes : wirePassengers;
  if (wirePassengers.length) {
    for (let i = 0; i < wirePassengers.length; i++) {
      intPassengers.push(flightPassengerToInt(wirePassengers[ i ]));
    }
  } else {
    intPassengers.push(flightPassengerToInt(wirePassengers));
  }

  return intPassengers;
}

function flightPassengerToInt (wirePassenger) {
  wirePassenger = wirePassenger._attributes ? wirePassenger._attributes : wirePassenger;
  const { contact_objectid, selected, FlightSeatID, SeatAssignmentID } = wirePassenger;

  return {
    id: contact_objectid,
    selected: selected === true || selected === 'true',
    seatId: FlightSeatID,
    seatAssignmentId: SeatAssignmentID,
  };
}



// WEBPACK FOOTER //
// ./src/converter/FlightsConverter.js